import React, { Component } from "react";
import Fade from "react-reveal";

class About extends Component {
  render() {

    const name = 'Manoj Kumar';
    const profilepic = "images/manoj_pic.jpg";
    const bio = 'Healthy arguments amidst my peers during the school days sparked my interest in the field of computer science. During Pandemic, I wondered how technology has been integrated into our daily life. It was high time that I spent and explored the world of developers. Knowing my interest, my family gifted me a Laptop to acheive my goals. From then on, I started creating simple projects along with my academics. Do check out my projects in Linkdin...';
    const email = 'mastromanoj1@gmail.com';
    const resumeDownload = 'https://www.linkedin.com/in/manoj-kumar-m-792081211/';

    return (
      <section id="about">
        <Fade duration={1000}>
          <div className="row">
            <div className="three columns">
              <img
                className="profile-pic"
                src={profilepic}
                alt="Nordic Giant Profile Pic"
              />
            </div>
            <div className="nine columns main-col">
              <h2>About Me</h2>

              <p>{bio}</p>
              <div className="row">
                <div className="columns contact-details">
                  <h2>Contact Details</h2>
                  <p className="address">
                    <span>{name}</span>
                   <br/>
                    <span>{email}</span>
                  </p>
                </div>
                <div className="columns download">
                  <p>
                    <a href={resumeDownload} className="button">
                      <i className="fa fa-linkedin"></i> Linkdin
                    </a>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </Fade>
      </section>
    );
  }
}

export default About;
